<div
  class="cc-image"
  [class.cc-image--box-shadow]="hasShadow"
  [class.cc-image--ratio]="hasRatio"
  [style.background]="background"
>
  <div class="cc-image__ratio-container" *ngIf="ratio !== 0" [ngStyle]="ratioStyles"></div>

  <img
    class="cc-image__image"
    [style]="customStyles"
    [attr.loading]="forceLoad ? 'eager' : 'lazy'"
    [src]="src"
    [sizes]="sizes"
    [alt]="altText || ''"
    [class.cc-image--opacity]="hasOpacity"
    [class.cc-image--full-screen]="isFullScreen"
    [class.cc-image--fixed-height]="fixedHeight"
    (load)="onImageLoaded($event)"
    (error)="onImageError($event, src)"
    width="100%"
    height="auto"
  />

  <!-- Spinner -->
  <div class="cc-image__spinner" *ngIf="state === imageState.Loading">
    <ccwb-spinner theme="dark" />
  </div>

  <!-- icon (if image loading failed) -->
  <div class="cc-image__error" *ngIf="state === imageState.ImageError">
    <ccwb-icon name="no-camera" />
  </div>
</div>
